import { render } from "./SceneSection.vue?vue&type=template&id=75822bd9&scoped=true"
const script = {}

import "./SceneSection.vue?vue&type=style&index=0&id=75822bd9&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75822bd9"]])

export default __exports__